import { api } from './client';
import type { PayoutSlot } from '@/lib/payouts';

export type HistoryListItem = {
  id: number;
  name: string;
  machineName: string;
  status: string;
  completedAt: string | null;
  myResult: {
    place: number | null;
    amountCents: number;
    paid: boolean;
  } | null;
};

export type HistoryListResponse = {
  items: HistoryListItem[];
  page: number;
  pageSize: number;
  total: number;
  hasMore: boolean;
};

export type HistoryEntry = {
  id: number;
  userId: number;
  userDisplayName: string | null;
  entryNumber: number;
  startingBalance: number | null;
  endingBalance: number | null;
  score: number | null;
  isTiebreaker: boolean;
  verifiedByAdmin: boolean;
  hasStartingPhoto: boolean;
  hasEndingPhoto: boolean;
};

export type HistoryPayout = {
  id: number;
  userId: number;
  userDisplayName: string | null;
  place: number;
  amountCents: number;
  paid: boolean;
  paidAt: string | null;
};

export type HistoryDetailResponse = {
  tournament: {
    id: number;
    name: string;
    machineName: string;
    status: string;
    entryFeeCents: number;
    payoutStructure: PayoutSlot[];
    startedAt: string | null;
    completedAt: string | null;
  };
  entries: HistoryEntry[];
  payouts: HistoryPayout[];
  potCents: number;
};

export type MeStats = {
  totalSpentCents: number;
  totalWinningsCents: number;
  uncollectedCents: number;
  netCents: number;
  totalEntries: number;
  winCount: number;
  placementCount: number;
  placements: Array<{
    tournamentId: number;
    tournamentName: string;
    machineName: string;
    completedAt: string | null;
    place: number;
    amountCents: number;
    paid: boolean;
    paidAt: string | null;
  }>;
};

export const historyApi = {
  list: (page: number, pageSize = 20) =>
    api.get<HistoryListResponse>(`/api/history?page=${page}&pageSize=${pageSize}`),
  detail: (id: number) =>
    api.get<HistoryDetailResponse>(`/api/history/${id}`),
  myStats: () => api.get<MeStats>('/api/me/stats'),
};
